import { render, staticRenderFns } from "./MenuBtn.vue?vue&type=template&id=7f872998&"
import script from "./MenuBtn.vue?vue&type=script&lang=js&"
export * from "./MenuBtn.vue?vue&type=script&lang=js&"
import style0 from "./MenuBtn.vue?vue&type=style&index=0&id=7f872998&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports